import { cn } from '@quadralize/utils'
import * as React from 'react'

interface ButtonGroupProps extends React.FieldsetHTMLAttributes<HTMLFieldSetElement> {
  orientation?: 'horizontal' | 'vertical'
}

const ButtonGroup = React.forwardRef<HTMLFieldSetElement, ButtonGroupProps>(
  ({ className, orientation = 'horizontal', children, ...props }, ref) => {
    return (
      <fieldset
        ref={ref}
        className={cn(
          'inline-flex m-0 p-0 border-none min-w-0 h-fit w-fit items-center', // Reset fieldset defaults
          'group/btn-group rounded-lg bg-bg-muted/30 dark:bg-neutral-900/40 p-0.5', // Subtle container for "island" look
          orientation === 'vertical' ? 'flex-col' : 'flex-row',
          // Rounded corners logic for all children
          '*:rounded-none',
          orientation === 'horizontal'
            ? '[&>*:first-child]:rounded-l-md [&>*:last-child]:rounded-r-md'
            : '[&>*:first-child]:rounded-t-md [&>*:last-child]:rounded-b-md',
          // Border merging logic
          orientation === 'horizontal' ? '[&>*+*]:-ml-px' : '[&>*+*]:-mt-px',
          // Ensure borders and focus rings of active/hovered items are on top
          '*:relative *:hover:z-10 *:focus-within:z-10',
          // Special border refinement for dark mode
          'dark:*:border-neutral-800',
          className,
        )}
        {...props}
      >
        {children}
      </fieldset>
    )
  },
)

ButtonGroup.displayName = 'ButtonGroup'

export { ButtonGroup }
